<template>
  <b-container>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col>
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Detail</label
            >
            <b-row>
              <b-col cols="3">
                <b-form-group label="Account" label-for="account">
                  <v-select
                    id="account"
                    v-model="form.selectedAccount"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsAccount"
                    placeholder="Select 1 Account"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedAccount"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedAccount }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Code" label-for="code">
                  <b-form-input
                    id="code"
                    placeholder="Code"
                    v-model="form.code"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Date" label-for="date">
                  <flat-pickr
                    id="date"
                    v-model="form.date"
                    class="form-control"
                    placeholder="Date"
                  />
                  <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                  <!-- <p>Value: '{{ form.date }}'</p> -->
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Receiver" label-for="receiver">
                  <b-form-input
                    id="receiver"
                    placeholder="Receiver"
                    v-model="form.receiver"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col>
                <label for="items" class="text-primary font-weight-bolder mb-1"
                  >Items</label
                >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  v-b-modal.modal-add
                  class="float-right mb-2"
                  >Add Item
                </b-button>
              </b-col>
            </b-row>
            <b-modal
              id="modal-add"
              ref="modal-add"
              centered
              title="Add Item"
              hide-footer
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Account" label-for="account_item">
                    <v-select
                      id="account_item"
                      v-model="form2.selectedAccountItem"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="form2.optionsAccountItem"
                      placeholder="Select 1 Account"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <!-- Selected: <strong>{{ form2.selectedAccountItem }}</strong> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Amount" label-for="amount">
                    <cleave
                      id="amount"
                      placeholder="Amount"
                      v-model="form2.amount"
                      class="form-control"
                      :raw="false"
                      :options="options.number"
                      :disabled="
                        form2.selectedAccountItem === null ? true : false
                      "
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    label="Description"
                    label-for="description_item"
                  >
                    <b-form-textarea
                      id="description_item"
                      placeholder="Description"
                      v-model="form2.description"
                      :disabled="
                        form2.selectedAccountItem === null ? true : false
                      "
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="my-1"
                    @click="addItemToTable()"
                    block
                    :disabled="form.selectedVendor === null ? true : false"
                  >
                    Add Item
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>
            <b-row>
              <b-col md="12">
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                    :src="props.row.avatar"
                                    class="mx-1"
                                /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">Rp {{ props.row.price }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                      <b-badge :variant="statusVariant(props.row.status)">
                        <span v-if="props.row.status === 1">Active</span>
                        <span v-else>Non-Active</span>
                      </b-badge>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span>
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            @click="
                              deleteItemFromTable(props.row.originalIndex)
                            "
                          >
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            @click="validation()"
            block
            :disabled="rows.length === 0 ? true : false"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BFormTextarea,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
    BModal,
    VBModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        selectedAccount: null,
        optionsAccount: [],
        date: null,
        receiver: "",
        description: "",
      },
      form2: {
        payable_id: null,
        selectedAccountItem: null,
        optionsAccountItem: [],
        amount: null,
        description: "",
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Account",
          field: "account_name",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-success",
        0: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAccounts();
  },
  methods: {
    getAccounts() {
      this.$http.get("finance/accounts").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsAccount.push($data);
          this.form2.optionsAccountItem.push($data);
        }
        // console.log(this.form.optionsAccount)
      });
    },
    addItemToTable() {
      this.$refs['modal-add'].hide()
      if (this.form2.selectedAccountItem === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Account Item field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.amount === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Amount field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else {
        var $data = {
          account_id: this.form2.selectedAccountItem.value,
          account_name: this.form2.selectedAccountItem.text,
          amount: this.form2.amount,
          description: this.form2.description,
        };
        this.rows.push($data);
        this.form2.selectedAccountItem = null;
        this.form2.amount = null;
        this.form2.description = null;
      }
    },
    deleteItemFromTable(index) {
      this.rows.splice(index, 1);
    },
    validation() {
      if (this.form.code === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Code field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedAccount === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Account field is required",
            variant: "warning",
          },
        });
      } else if (this.form.date === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Date field is required",
            variant: "warning",
          },
        });
      } else if (this.form.receiver === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Receiver field is required",
            variant: "warning",
          },
        });
      } else if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else {
        this.addPayable();
      }
    },
    addPayable() {
      if (this.form.selectedAccount !== null) {
        var $accountID = this.form.selectedAccount.value;
      }
      this.$http
        .post("finance/payable/add", {
          code: this.form.code,
          account_id: $accountID,
          date: this.form.date,
          receiver: this.form.receiver,
          description: this.form.description,
        })
        .then((response) => {
          this.form2.payable_id = response.data.data.id;
          var $datas = this.rows;
          var i;
          for (i = 0; i < $datas.length; i++) {
            var newAmount = $datas[i].amount;
            newAmount = newAmount.replace(/\,/g, "");
            var $data = {
              payable_id: this.form2.payable_id,
              account_id: $datas[i].account_id,
              amount: newAmount,
              description: $datas[i].description,
            };
            // console.log($data)
            this.addPayableItems($data);
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Payable",
              variant: "success",
            },
          });
          setTimeout(function () {
            location.href = "/finance/payable";
          }, 2000);
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    addPayableItems($data) {
      this.$http
        .post("finance/payable/item/add", $data)
        .then((response) => {
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>